import { Box, CheckBox, ColorOptions, SpacerNew, TextNew } from '@jfs/ui-new'
import { DateType, getDateFromNumberOfDays } from '@jfs/utils'
import { useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { TooltipView } from '../../../../../src/comps/TootTipView'
import './datePicker.css'
import { styles } from './ReportingStyles'

export const ReportValidityDatePicker = ({
  fieldName,
  setFieldValue,
  allValues,
  label,
  placeholder,
  ...props
}: any) => {
  const getSelectedDate = (date: any) => {
    try {
      if (date) {
        return new Date(date)
      } else {
        return ''
      }
    } catch (error) {
      console.log('not able to parse')
      return new Date()
    }
  }

  const [date, setDate] = useState(getSelectedDate(allValues[fieldName]))
  const [untilCancel, setUntilCancel] = useState(false)
  const onChangeDate = (selectedDate: Date) => {
    if (fieldName && setFieldValue) {
      setFieldValue(fieldName, selectedDate.toString())
    }
    setDate(selectedDate)
  }
  const handleCheckBox = (value: any) => {
    setUntilCancel(value)
    if (value && fieldName && setFieldValue) {
      setFieldValue(fieldName, getDateFromNumberOfDays(365 * 100, DateType.FUTURE))
    } else {
      setFieldValue(fieldName, '')
    }
  }
  return (
    <Box {...styles.mainView}>
      <Box {...styles.textAndIcon}>
        <Box {...styles.titleAligner}>
          <TextNew title={label} {...styles.titleText} />
        </Box>
        <Box>
          <TooltipView
            iconColor={'#202F4D8A' as ColorOptions}
            fontSize={12}
            value={props.tooltipInfo ?? ''}
            top={props.top ?? 0}
            iconSize={14}
          />
        </Box>
      </Box>
      <SpacerNew size={5} direction={'vertical'} />
      <Box {...styles.superContainer}>
        <DatePicker
          placeholder={placeholder}
          portalId={fieldName}
          dateFormat="dd/MM/yyyy"
          selected={date ?? ''}
          minDate={new Date()}
          onChange={onChangeDate}
          disabled={untilCancel}
          className="datePicker"
        />
      </Box>
      <Box mt={10}>
        <CheckBox
          checked={untilCancel}
          textLabel={'Until Cancel'}
          alignBox={'center'}
          testID={'checkbox_' + fieldName}
          onChecked={handleCheckBox}
          fontSize={'SMALL'}
          //spacerSize={10}
          iconSize={'MEDIUM'}
        />
      </Box>
    </Box>
  )
}
